import { PageSection } from 'types/Sections';
import { isDefault, isMain, isSectionMegamenu } from 'utils/functions/checkSectionType';

export const getMainSections = (sections: PageSection[]) => {
  return sections.filter(section => {
    return isMain(section.type) || isDefault(section.type) || isSectionMegamenu(section.type);
  });
};
